import { Col, Layout, Row, Spin, Table, Tag } from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { Constant } from '../../config';
import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import SearchForm from '../SearchForm';

const { Content } = Layout;

class DeliveryLogsBlackhole extends Component {
  state = {
    currentPage: 1,
    currentSearch: '',
    dataSource: [],
    loading: false,
    totalRows: 0,
  };

  columns = [
    {
      align: 'center',
      dataIndex: 'created',
      render: (created) => {
        if (!created) return '-';

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {created}
          </Moment>
        );
      },
      title: 'Date / Time',
      width: '150px',
    },
    {
      align: 'center',
      dataIndex: 'member_id',
      render: (_, record) => {
        return record.member_detail ? record.member_detail.email || '-' : '-';
      },
      title: 'Email',
      width: '150px',
    },
    {
      align: 'center',
      dataIndex: 'phone',
      render: (phone, record) => {
        return (
          <span>
            <span>{phone}</span>
            <br />
            <Tag color="brown">{record.receiver_country || '-'}</Tag>
          </span>
        );
      },
      title: 'Phone No.',
      width: '150px',
    },
    {
      dataIndex: 'msg',
      render: (msg, record) => {
        return (
          <span>
            <span>{msg}</span>
            <br />
            <Tag color="orange">Sender: {record.sender_name || '-'}</Tag>
            <Tag color="red" style={{ marginBottom: '8px' }}>
              Total SMS: {record.total_sms || '-'}
            </Tag>
            <br />
            <Tag color="blue" style={{ marginBottom: '8px' }}>
              Message ID: {record.message_id || '-'}
            </Tag>
            <br />
            <Tag color="cyan">Client rate: {record.client_rate || '-'}</Tag>
            <Tag color="green">Market rate: {record.market_rate || '-'}</Tag>
          </span>
        );
      },
      title: 'Message',
      width: '400px',
    },
  ];
  columnsMobile = [];
  limit = 10;

  componentWillMount() {
    this.props.fetchMenuAction('sms-logs', 'sms-logs-blackhole');
    this.setState({ loading: true });
  }

  async componentDidMount() {
    await this.getDataList();
    this.setState({ loading: false });
  }

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(page, this.state.currentSearch);

    this.setState({ loading: false });
  };

  getDataList = async (page = 1, search = '') => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.DELIVERY_LOGS_BLACKHOLE_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      params: {
        page,
        limit: this.limit,
        search,
        order: 'DESC',
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");
    } catch (e) {
      console.error(e);
      this.initialState();
      return;
    }

    this.setState({
      currentPage: resp.data.page || 1,
      dataSource: resp.data.data || [],
      loading: false,
      totalRows: resp.data.total_rows || 0,
    });
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      this.setState({
        currentPage: 1,
        currentSearch: values.searchTxt,
        loading: true,
      });

      await this.getDataList(1, values.searchTxt);

      this.setState({ loading: false });
    });
  };

  resetSearch = async () => {
    this.setState({ loading: true });

    await this.getDataList(1);

    this.setState({ loading: false });
  };

  render() {
    const propsTable = {
      bordered: true,
      className: 'my-table',
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: 'id',
      pagination: {
        pageSize: this.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: 'small',
      },
      size: 'small',
      // scroll: {
      //   x: 1200,
      // },
    };
    const propsTableForMobile = Object.assign({}, propsTable);

    propsTableForMobile.className = 'my-table-mobile';
    propsTableForMobile.columns = this.columnsMobile;

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: '#fff',
              padding: 24,
              margin: '16px 0',
              minHeight: 300,
            }}
          >
            <h2>Delivery Logs Blackhole</h2>
            <p className="header-desc">
              SMS ที่ถูกดักจับจาก Keyword Blackhole และไม่ส่งต่อไปยัง Gateway Operator.
            </p>
            <Row className="utility-bar">
              <Col span={12}></Col>
              <Col span={12}>
                <SearchForm
                  fn={this.mySearch}
                  fnReset={this.resetSearch}
                  placeholder="Email, Message ID, Phone No."
                  width="300px"
                />
              </Col>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm fn={this.mySearch} fnReset={this.resetSearch} />
            </Row>
            <Table {...propsTable} />
            <Table {...propsTableForMobile} />
          </Content>
        </Spin>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(DeliveryLogsBlackhole);



// WEBPACK FOOTER //
// ./src/containers/DeliveryLogsBlackhole/index.js